// extracted by mini-css-extract-plugin
export default {"appLayoutContainer":"AppLayout_appLayoutContainer__dnkxf","appLayoutContent":"AppLayout_appLayoutContent__bjVqS"};